import Vue from 'vue';
import VueRouter from 'vue-router';

import application from './modules/Application';
import fiscal from './modules/Fiscal';
import dashboard from './modules/Dashboard';
import payment from './modules/Payment';
import news from './modules/News';
import pdv from './modules/Fiscal/modules/Pdv';
import nfse from './modules/Fiscal/modules/Nfse';
import cfopParameterization from './modules/Fiscal/modules/CfopParameterization';
import inventory from './modules/Inventory';
import purchase from './modules/Inventory/modules/Purchase';
import serviceOrder from './modules/Inventory/modules/ServiceOrder/routes';
import BeneficioFiscal from './modules/Fiscal/modules/Beneficio';

Vue.use(VueRouter);

const routes = [
  ...payment,
  ...dashboard,
  ...fiscal,
  ...application,
  ...news,
  ...pdv,
  ...inventory,
  ...purchase,
  ...nfse,
  ...serviceOrder,
  ...BeneficioFiscal,
  ...cfopParameterization,
  {
    path: '/*',
    beforeEnter: () => {
      window.location.href = '/';
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

export default router;
